import { render } from "./ColItem.vue?vue&type=template&id=61ff20d4"
import script from "./ColItem.vue?vue&type=script&lang=js"
export * from "./ColItem.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])